import { ScreenHeading, VidaLogo } from '@/modules/ui';

type AccountHeaderProps = {
  title: string;
  // Optional so a screen gating its subheader on a feature flag can withhold it
  // until the arm resolves, rather than paint one arm's copy and correct it.
  subtitle?: string;
};

// Shared masthead for the account-creation flows: logo + title/subtitle. Submit
// errors are a per-flow concern (some surface them on a field, others as a
// banner), so each screen renders its own.
export function AccountHeader({ title, subtitle }: AccountHeaderProps) {
  return (
    <>
      <VidaLogo width={112} height={29} />

      <ScreenHeading title={title} subtitle={subtitle} />
    </>
  );
}
